
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 8H5v8h11V8z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M7 10h4m-2 1v3.5m5 1.5h3m-3-8h1.5m0 0H17m-1.5 0v7M2.5 5h19a1 1 0 011 1v12a1 1 0 01-1 1h-19a1 1 0 01-1-1V6a1 1 0 011-1z","stroke":"#4A4A4A","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    